import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITrade } from "../interface/trade/ITrade";
import { IUpdateTradeAddress } from "src/pages/contingency/trade-maintenance/EditTrade/EditAddressComponent/IUpdateTradeAddress";
import { IUpdateTradeSpouse } from "src/pages/contingency/trade-maintenance/EditTrade/EditTradeSpouseComponent/IUpdateTradeSpouse";
import { IUpdateTradeBank } from "src/pages/contingency/trade-maintenance/EditTrade/EditBankInfoComponent/IUpdateTradeBank";
import { generateQueryString } from "src/util/helper";
import { ITradeOwner } from "../interface/trade/Owner/ITradeOwner";
import { IReassignLawFirmRequest } from 'src/pages/contingency/trade-maintenance/EditTrade/EditTradeLawFirmComponent/IReassignLawFirmRequest';
import { IEditTradeSpecialProjectContingency } from '../interface/specialProject/IEditTradeSpecialProjectContingency';
import { IReprocessPaymentRequestContingency } from '../interface/IReprocessPaymentRequestContingency';
import { IBaseResponse } from '../interface/IBaseResponse';
import { IEditTradeUserContingency } from '../interface/trade/IEditTradeUserContingency';
import { ISwitchDisbursementMethod } from '../interface/trade/ISwitchDisbursementMethod';

enum TradeServiceEnum {
  updateTradePricingFromContingency = "/update-trade-pricing-from-contingency",
  updateTradeOwnerFromContingency = "/owner",
  updateTradeAddressFromContingency = "/address",
  updateTradeSpouseFromContingency = "/spouse",
  updateTradeBankInfoFromContingency = "/bank",
  updateTradeLawyerFromContingency = "/update-trade-lawyer-from-contingency",
  reprocessPaymentRequest = "/reprocess-payment-request",
  requestCessionContractSignatureContingency = "/request-cession-contract-signature-contingency",
  updateTicketLawFirmContingency = "/law-firm",
  postUpdateSpecialProject = "/special-project",
  updateUser = "/change-trade-user",
  switchDisbursementMethod = "/switch-disbursement-method"
}

export default class TradeContingencyService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/contingency");
  }
  public switchDisbursementMethod = async (request: ISwitchDisbursementMethod): Promise<void> => await this.POST(TradeServiceEnum.switchDisbursementMethod, request);
  public postUpdateTradeOwnerFromContingency = async (request: ITradeOwner): Promise<ITrade> => await this.POST(TradeServiceEnum.updateTradeOwnerFromContingency, request);
  public postUpdateTradeSpouseFromContingency = async (request: IUpdateTradeSpouse): Promise<ITrade> => await this.POST(TradeServiceEnum.updateTradeSpouseFromContingency, request);
  public postUpdateTradeAddressFromContingency = async (request: IUpdateTradeAddress): Promise<ITrade> =>
    await this.POST(TradeServiceEnum.updateTradeAddressFromContingency, request);
  public postUpdateTradeBankInfoFromContingency = async (request: IUpdateTradeBank): Promise<ITrade> =>
    await this.POST(TradeServiceEnum.updateTradeBankInfoFromContingency, request);
  public postUpdateTicketLawFirm = async (request: IReassignLawFirmRequest): Promise<any> => await this.POST(TradeServiceEnum.updateTicketLawFirmContingency, request);
  public postUpdateSpecialProject = async (request: IEditTradeSpecialProjectContingency) =>
    await this.PUT(TradeServiceEnum.postUpdateSpecialProject, request);
  public postUpdateTradePricingFromContingency = async (trade): Promise<ITrade> => await this.POST(TradeServiceEnum.updateTradePricingFromContingency, trade);
  public postUpdateTradeLawyerFromContingency = async (trade): Promise<ITrade> => await this.POST(TradeServiceEnum.updateTradeLawyerFromContingency, trade);
  public putRequestCessionContractSignatureContingency = async (tradeId: number) =>
    await this.PUT(`${TradeServiceEnum.requestCessionContractSignatureContingency}${generateQueryString({ tradeId })}`, tradeId);
  public postReprocessPaymentRequestFromContingency = async (request: IReprocessPaymentRequestContingency): Promise<IBaseResponse> => await this.POST(TradeServiceEnum.reprocessPaymentRequest, request);
  public postUpdateTradeUserFromContingency = async (request: IEditTradeUserContingency): Promise<void> => await this.PUT(TradeServiceEnum.updateUser, request);

}
